import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { ToastService } from 'angular-toastify';
import { UserService } from '../../../core/services/user.service';
import { AuthActions } from '../../../core/state/auth/auth.actions';
import { selectPreAuth } from '../../../core/state/auth/auth.selector';
import { Router } from '@angular/router';
import { AuthService } from '../../../core/services/auth.service';
import { PRIMITIVE_VALUES } from '../../../core/constants/constants';
import { IProfileState } from '../../../core/interfaces/user.interface';
import { HttpErrorResponse } from '@angular/common/http';
import { extractErrorMessage } from '../../../core/utils/extract-error-message.util';

@Component({
  selector: 'app-two-factory-authentication',
  templateUrl: './two-factory-authentication.component.html',
  styleUrl: './two-factory-authentication.component.scss',
})
export class TwoFactoryAuthenticationComponent implements OnInit {
  public profile$ = this.store.select(selectPreAuth);
  public tfaForm: FormGroup;
  public profile: IProfileState | null = null;
  public id: string = '';
  public isgood: boolean = false;

  constructor(
    private toast: ToastService,
    private fb: FormBuilder,
    private store: Store,
    private _userService: UserService,
    private router: Router,
    private _authService: AuthService,
  ) {
    this.tfaForm = this.fb.group({
      TFA: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.profile$.subscribe((profile) => {
      if (profile.idusuario > PRIMITIVE_VALUES.ZERO) {
        this.id = String(profile.idusuario);
      }
    });
  }

  onSubmit() {
    if (!this.id) {
      this.toast.error('Sesión previa inválida. Inicia sesión nuevamente.');
      this.router.navigate(['/auth/login']);
      return;
    }

    const twoFactorAuth = this.tfaForm.value;
    this._userService.verifyLogin(this.id, twoFactorAuth.TFA).subscribe({
      next: (response) => {
        this.isgood = true;
        this._userService.getUser(response.data.idusuario).subscribe({
          next: (response) => {
            this._authService.unlock();
            this.store.dispatch(
              AuthActions['[Auth]LoginSuccess'](response.data),
            );
            this.router.navigate(['']);
            this.toast.default(`Bienvenido, ${response.data.usuario}`);
          },
          error: () => {
            this.toast.error('No se pudo cargar el perfil del usuario.');
          },
        });
      },
      error: (error: HttpErrorResponse) => {
        this.toast.error(extractErrorMessage(error, 'es', 'Código 2FA inválido.'));
      },
    });
  }

  backLogin() {
    this._authService.logOut();
  }
}
